export function createDefaultTranscriptionHostAdapter(overrides = {}) {
  return {
    getRoomId: () => null,
    getLocalSpeakerIdentity: () => ({
      speaker: null,
      speakerId: null,
      speakerRoomSessionId: null
    }),
    getCurrentDisplayName: () => null,
    shouldRenderCaption: () => true,
    ...overrides
  };
}

export function resolveTranscriptionHostAdapter(hostAdapter) {
  return createDefaultTranscriptionHostAdapter(hostAdapter || {});
}
